import SettingTypes from "@/utils/setting-types";

export default {
  name: "contact-customer-service",
  label: {
    title: "在线客服",
    icon: require("@/assets/icon-contact-service.png"),
    limit: 1,
  },
  sort: 30,
  data: {
    background_image:'',
    image_size:40,
    is_position_left:true,
    position_height:580

  },
  settings: {
    background_image: {
      type: SettingTypes.custom,
      component_name: 'BackgroundImage'
    },
    image_size: {
      type: SettingTypes.slider,
      label: '图片大小',
      props: {
        min: 0,
        max: 100
      }
    },
    is_position_left: {
      type: SettingTypes.radio_button,
      label: '图片位置',
      options: [
        { label: '左边', value: true },
        { label: '右边', value: false }
      ]
    },
    position_height: {
      type: SettingTypes.slider,
      label: '图片高度',
      props: {
        min: 0,
        max: 1000
      }
    }
  },
};
